<button
  class="text-sm font-semibold"
  [disabled]="disabled"
  [ngClass]="{
    'text-cancel': color === 'red',
    'text-blue': color !== 'red',
    'text-grey': disabled || isLoading,
    'focus:outline-none': !showOutline,
    'cursor-wait': isLoading,
  }"
>
  <ng-content></ng-content>
  <ng-container
    *ngTemplateOutlet="
      content;
      context: { isLoading: isLoading, disabled: disabled }
    "
  ></ng-container>
</button>
